import { motion } from 'motion/react';
import { memo } from 'react';
import ChevronDown from '@/app/components/questionnaireV2/icons/chevron-down';
import CategoryCardBase from './category-card-base';
import { DataCategoryCardProps } from './types';

export const DataCategoryCard = memo(function DataCategoryCard({
  name,
  description,
  icon,
  progressValue,
  progressMax,
  lastUpdated,
  isComplete,
  isEditMode = false,
  onReviewClick,
}: DataCategoryCardProps) {
  return (
    <CategoryCardBase
      name={name}
      description={description}
      icon={icon}
      progressValue={progressValue}
      progressMax={progressMax}
      lastUpdated={lastUpdated}
      isComplete={isComplete}
    >
      {/* Review/Edit Button */}
      <motion.button
        onClick={onReviewClick}
        className="relative box-border flex h-[40px] w-full lg:max-w-72 shrink-0 items-center justify-center rounded-[100px] bg-[#183344] px-[20px]"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.2 }}
        aria-label={`${isEditMode ? 'Edit' : 'Review'} ${name}`}
        type="button"
      >
        <span className="text-[14px] leading-[1.4] font-bold text-white">{isEditMode ? 'Edit' : 'Review'}</span>
        {isEditMode && <ChevronDown className="absolute right-5 h-4 w-4 text-white" />}
      </motion.button>
    </CategoryCardBase>
  );
});

export default DataCategoryCard;
